import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Box from "@mui/material/Box";
import {Chip, Divider, IconButton, Stack, Typography} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import React from "react";
import Button from "@mui/material/Button";

export default function Roles(props) {

    return (<Dialog
        open={props.open}
        onClose={props.onClose}
        fullWidth
        maxWidth={"xs"}
        scroll="paper"
    >
        <DialogTitle>
            <Box display="flex" alignItems="center">
                <Box flexGrow={1}>
                    <Stack
                        direction={"row"}
                        spacing={1}
                        divider={<Divider orientation="vertical" flexItem/>}
                    >
                        <Typography variant={"h5"}>My Roles</Typography>
                    </Stack>
                </Box>
                <Box>
                    <IconButton onClick={props.onClose}>
                        <CloseIcon/>
                    </IconButton>
                </Box>
            </Box>
        </DialogTitle>

        <DialogContent dividers>
            <Box>

                <Stack direction="row" spacing={0} flexWrap="wrap">
                    {props.roles?.map((role, index) => (
                        <Chip key={index} variant='outlined' color='primary' label={role}
                              style={{minWidth: '100px', margin: '5px'}}/>
                    ))}
                </Stack>

                <Stack spacing={2} paddingTop={2} direction="row-reverse">
                    <Button
                        onClick={props.onClose}
                        variant="contained"
                        aria-label="save"
                        startIcon={<CloseIcon/>}
                    >
                        Close
                    </Button>
                </Stack>
            </Box>
        </DialogContent>
    </Dialog>);
}
